



















































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
//@ts-ignore
import { Affix } from 'vue-affix'

@Component({
  components: {
    Affix
  }
})
export default class AdminContentCampaignShowSideNavigation extends Vue {

  scrollPageTo(navEl) {
    let element = document.querySelector(`#${navEl}`)
    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

}
